import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/store.js'
import { iStorage } from 'smart-core-util';
import iJsbridge from 'smart-javascript-bridge'
// import iJsBridge  from '@/library/smart-javascript-bridge/src/index'
import * as tinyCookie from 'tiny-cookie'
import config from '@/api/config'
// iStorage.setAll({
//   token:"eyJhbGciOiJSUzI1NiIsImtpZCI6ImIwMzczNmU3MjE0ZDZhYTBkODYwOGQ1YzUzMDUwYWQxIiwidHlwIjoiSldUIn0.eyJuYmYiOjE1MzI4NTQ3NDksImV4cCI6MTU2Mzk1ODc0OSwiaXNzIjoiaHR0cDovL3Bhc3Nwb3J0LmRldi5zbWFydHhjbG91ZC5jbiIsImF1ZCI6WyJodHRwOi8vcGFzc3BvcnQuZGV2LnNtYXJ0eGNsb3VkLmNuL3Jlc291cmNlcyIsIkFwaXMuQWRtaW4iLCJBcGlzLkNoZWNrQWNjb3VudCIsIkFwaXMuQ29uZmlndXJhdGlvbiIsIkFwaXMuRXZlbnQiLCJBcGlzLkZpbGUiLCJBcGlzLkZsb3ciLCJBcGlzLkZvdW5kYXRpb24iLCJBcGlzLklkZW50aXR5IiwiQXBpcy5JbnZvaWNlIiwiQXBpcy5NZWFsIiwiQXBpcy5NZXNzYWdlIiwiQXBpcy5NeVByb2ZpbGUiLCJBcGlzLlNob3BLZWVwZXIiLCJBcGlzLlNtYXJ0QWxpcGF5IiwiQXBpcy5TbWFydEV2ZW50IiwiQXBpcy5TbWFydEpvYi5GaW4iLCJBcGlzLlZlbnVlIiwiZWMub3JkZXIiLCJwYXNzcG9ydCIsInNtYXJ0eGFwcCIsIndvcmtmbG93Il0sImNsaWVudF9pZCI6ImFwcHMudGVuYW50Iiwic3ViIjoiZmIyYzdiODYtYmRlZS00YTNiLTgxZTQtYTQyYjRlZDg1OTBmIiwiYXV0aF90aW1lIjoxNTMyODU0NzQ5LCJpZHAiOiJsb2NhbCIsImlkIjoiZmIyYzdiODYtYmRlZS00YTNiLTgxZTQtYTQyYjRlZDg1OTBmIiwibmFtZSI6Im51cjMiLCJuaWNrbmFtZSI6Im51cjMiLCJyb2xlX2NvZGVzIjoiRVguQWxpcGF5LEVYLkludm9pY2VNYW5nZSxFWC5Gb3VuZGVyIiwidGVuYW50X2lkIjoiZGMzMGJmZmMtYzdiMS00Njg2LTkyMzEtMWMwYzY5ZDdjZjRjIiwidGVuYW50X2NvZGUiOiJub3ZhcnRpcyIsInZlcnNpb24iOiI2NiIsInNjb3BlIjpbIkFwaXMuQWRtaW4iLCJBcGlzLkNoZWNrQWNjb3VudCIsIkFwaXMuQ29uZmlndXJhdGlvbiIsIkFwaXMuRXZlbnQiLCJBcGlzLkZpbGUiLCJBcGlzLkZsb3ciLCJBcGlzLkZvdW5kYXRpb24iLCJBcGlzLklkZW50aXR5IiwiQXBpcy5JbnZvaWNlIiwiQXBpcy5NZWFsIiwiQXBpcy5NZXNzYWdlIiwiQXBpcy5NeVByb2ZpbGUiLCJBcGlzLlNob3BLZWVwZXIiLCJBcGlzLlNtYXJ0QWxpcGF5IiwiQXBpcy5TbWFydEV2ZW50IiwiQXBpcy5TbWFydEpvYi5GaW4iLCJBcGlzLlZlbnVlIiwiZWMub3JkZXIiLCJwYXNzcG9ydCIsInNtYXJ0eGFwcCIsIndvcmtmbG93Iiwib2ZmbGluZV9hY2Nlc3MiXSwiYW1yIjpbImN1c3RvbSJdfQ.btB4o2FCQeGDpvpPL_bHSlMiEMZMXHIDDSnLap3Vy8dYnrHiTJlzLVS730HvSpOudi53eZAF5hN--lUtObhAiZVIynScv-fBlRAIk5RdtYyu9GDP0jWRTvY5L2tBYbv_0eCuMv-whL_8wx-wm3cJPeFQshSMXnVze8DkR_xw4UeiGixzTq4_bNVPxwNAEIKEtvwLwgANUU0kGaxlygIAdbm5Qy1nqSq7Bv0yudlVNSCQPcYREAQLDCh-o9JV_0SXugGeh420LawWeTek_p6NmBAi7DvhFbytSmCgeLm1hKvRKgYGlGPCzR5Hw4LjOHAxlJSDkVg0_jVdcYZvwqkSIA",
//   "Uris":{"Uris":{"engine-api":"https://engine-api.smarteventcloud.cn","gateway":"https://gateway.smarteventcloud.cn","passport":"http://passport.smartxcloud.cn","signalr":"https://signalr.smarteventcloud.cn","smartalipay":"https://smartalipay.smarteventcloud.cn","sso-roche":"https://b2b.roche.com/idp/startSSO.ping?PartnerSpId=https://signin.smarteventcloud.cn/saml","sso-roche-logout":"https://b2b.roche.com/siteminderagent/forms/logoff.fcc?TARGET=https://b2b.roche.com/idp/startSSO.ping?PartnerSpId=https://signin.smarteventcloud.cn/saml","webapp-iaccount":"https://iaccount-webapp.smarteventcloud.cn","webapp-icar":"https://icar-webapp.smarteventcloud.cn","webapp-idelegate":"http://idelegate-webapp.smarteventcloud.cn","webapp-ievent":"https://ievent-webapp.smarteventcloud.cn","webapp-ihelper":"https://ihelper-webapp.smarteventcloud.cn","webapp-ijob":"https://ijob-webapp.smarteventcloud.cn","webapp-imaterial":"http://imaterial-webapp.smarteventcloud.cn","webapp-imeal":"https://imeal-webapp.smarteventcloud.cn","webapp-imyprofile":"https://imyprofile-webapp.smarteventcloud.cn","webapp-ivenue":"https://ivenue-webapp.smarteventcloud.cn","webapp-mshop":"https://mshop-webapp.smarteventcloud.cn","webapp-qshop":"http://qshop-webapp.smarteventcloud.cn","webpart-ievent":"https://ievent-webparts.smarteventcloud.cn"}}
// })
//mint-ui
iStorage.install()
import 'mint-ui/lib/style.css'
import MintUI from 'mint-ui';
Vue.use(MintUI)
//header
import MHeader from '@/components/header.vue'
Vue.component('m-header', MHeader)
//css
import '@/styles/index.scss'
import '@/styles/themes/default.scss'
//icon
import '@/assets/iconfont/iconfont.js' 

Vue.config.productionTip = false
//validate
import validate from '@/utils/validate'
//toast
import toast from '@/utils/toast'
//webview
import Webview from '@/utils/Webview' 


/**初始化css */
//import '@/assets/css/initStyle.scss';
/**公共皮肤 */
import '@/assets/css/theme.scss';
//全局css
//import '@/assets/css/public.css';

//prototype
Vue.prototype.validate = validate
Vue.prototype.toast = toast
Vue.prototype.bus = new Vue()
Vue.prototype.iStorage = iStorage
Vue.prototype.webview = new Webview()
Vue.prototype.JSbridge = new iJsbridge({ alert: alert })
Vue.prototype.$cookies = tinyCookie;
Vue.prototype.config = config

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js